/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputIcon from 'DesignSystem/TysiaInput/TysiaInputIcon/index'



/** @type {import('Simple/types.js').View} */
export default function SearchInput({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Patient/Content/PatientSearch/SearchInput",
  onFocus,
  onChange
  
}) {
let patientSelectSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'patient_select',
path: 'search_term',
})
let patientSelectSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'patient_select',
path: 'search_term',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 onFocus={onFocus}
 marginTop={dtSpaceXs}
 marginBottom={dtSpaceXs}
 type="text"
 size="small"
 placeholder="Enter patient ID, phone, name, dob, email"
 data="patient_select.search_term"
 value={patientSelectSearchTermValueData}
 onChange={patientSelectSearchTermChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputIcon
{...childProps}
  viewPath={`${viewPath}/TysiaInputIcon`}
>
{childProps => (
<TysiaIconSearch
{...childProps}
  viewPath={`${viewPath}/TysiaIconSearch`}
/>
)}
</TysiaInputIcon>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}